import { Button, Flex } from "@radix-ui/themes";

type FilterFooterProps = {
  onReset: () => void;
  onApply: () => void;
  variant?: "default" | "bordered";
};

export default function FilterFooter({
  onReset,
  onApply,
  variant = "default",
}: FilterFooterProps) {
  const containerClass =
    variant === "bordered"
      ? "justify-between items-center pt-3 border-t border-white/10 shrink-0"
      : "justify-between items-center";

  return (
    <Flex className={containerClass}>
      <Button onClick={onReset} variant="ghost" size="2" className="text-white">
        Reset
      </Button>
      <Button onClick={onApply} className="h-[34px] rounded-full">
        Apply
      </Button>
    </Flex>
  );
}
